import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="nested-fields"
export default class extends Controller {
  static targets = ["list", "template"];

  add(event) {
    event.preventDefault();
    const html = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      Date.now(),
    );
    this.listTarget.insertAdjacentHTML("beforeend", html);
  }

  remove(event) {
    event.preventDefault();
    const item = event.target.closest("[data-nested-fields-target='item']");
    const destroyField = item.querySelector("input[name*='_destroy']");

    if (destroyField) {
      destroyField.value = "1";
      item.style.display = "none";
    } else {
      item.remove();
    }
  }
}
